import type { Lane, Position } from "@board/positions";
import type { VisitBoard } from "@visits/visitsClient";

/** What a board card reads; the workstation's visit feeds and a paired board's view both map into it. */
export interface BoardVisit {
  id: string;
  patientId: string;
  patientName: string;
  /** As the card prints it: pet name, then the client's surname. */
  name: string;
  /** One card per household outside the exam room (BRI-382); the label is derived, never a person's name. */
  householdId: string;
  householdLabel: string;
  visitType: string;
  flow: Lane;
  position: Position;
  progressAt: string | null;
  roomId: string | null;
  roomName: string | null;
  dvmName: string | null;
  scheduledStart: string | null;
  scheduledEnd: string | null;
  createdAt: string;
  board: VisitBoard | null;
}

export const withSurname = (name: string, surname: string | null): string => {
  const family = surname?.trim();
  if (!family || name.toLowerCase().endsWith(family.toLowerCase())) return name;
  return `${name} ${family}`;
};
